import { getElement, toggleVisibility } from '../utils/dom-utils';
import { getGridApi, getOriginalData } from '../state/app-state';

export function updateCounts(): void {
  const gridApi = getGridApi();
  if (!gridApi) return;

  const displayed = gridApi.getDisplayedRowCount();
  const total = getOriginalData().length;

  const rowCountEl = getElement('rowCount');
  const filteredCountEl = getElement('filteredCount');

  if (rowCountEl) {
    rowCountEl.textContent = `${displayed} rows`;
  }

  if (filteredCountEl) {
    if (displayed < total) {
      filteredCountEl.textContent = `(filtered from ${total})`;
    } else {
      filteredCountEl.textContent = '';
    }
  }
}

export function showStatusBar(): void {
  const statusBar = getElement('statusBar');
  toggleVisibility(statusBar, true);
}

export function hideStatusBar(): void {
  const statusBar = getElement('statusBar');
  toggleVisibility(statusBar, false);
}
